import { Link } from 'react-router-dom';

const articles = [
  {
    title: 'Sugargoo Shipping Cost 2026: Complete Price Breakdown',
    desc: 'Understand every shipping method, cost level, and delivery timeline. Learn how to minimize international shipping fees and choose the best option for your order size.',
    path: '/sugargoo-shipping-cost-guide',
    img: 'https://readdy.ai/api/search-image?query=A%20cardboard%20shipping%20box%20wrapped%20with%20brown%20kraft%20paper%20and%20twine%20placed%20next%20to%20a%20small%20globe%20and%20measuring%20tape%20on%20a%20cream%20surface%20with%20soft%20natural%20side%20lighting%20editorial%20product%20photography%20warm%20neutral%20tones&width=600&height=400&seq=thumb-shipping-01&orientation=landscape',
  },
  {
    title: 'Is Sugargoo Legit? Complete Safety Review & Buyer Protection',
    desc: 'Honest review covering platform legitimacy, buyer protection policies, warehouse security, QC process, and what every new user should verify before purchasing.',
    path: '/is-sugargoo-legit',
    img: 'https://readdy.ai/api/search-image?query=A%20golden%20shield%20icon%20symbol%20next%20to%20a%20checkmark%20and%20a%20small%20padlock%20all%20resting%20on%20a%20cream%20surface%20with%20soft%20natural%20lighting%20conceptual%20product%20photography%20representing%20safety%20and%20trust%20clean%20minimalist%20style&width=600&height=400&seq=thumb-legit-01&orientation=landscape',
  },
  {
    title: 'Sugargoo Coupon Codes 2026: How to Find & Use Discounts',
    desc: 'Discover where to find the latest Sugargoo discount codes, how seasonal promotions work, and proven strategies to stack savings on every international order.',
    path: '/sugargoo-coupon-guide',
    img: 'https://readdy.ai/api/search-image?query=A%20collection%20of%20colorful%20discount%20tags%20and%20a%20small%20gift%20card%20elegantly%20arranged%20next%20to%20a%20wallet%20on%20a%20cream%20surface%20with%20warm%20natural%20side%20lighting%20editorial%20photography%20clean%20minimalist%20aesthetic&width=600&height=400&seq=thumb-coupon-01&orientation=landscape',
  },
  {
    title: 'Sugargoo Beginner Guide: How to Start Shopping from China',
    desc: 'A friendly step-by-step introduction for first-time users. Learn account setup, navigation basics, product searching, and how to place your very first order confidently.',
    path: '/sugargoo-beginner-guide',
    img: 'https://readdy.ai/api/search-image?query=An%20open%20notebook%20with%20a%20pencil%20and%20a%20smartphone%20displaying%20a%20shopping%20app%20interface%20arranged%20on%20a%20cream%20desk%20with%20soft%20natural%20window%20light%20editorial%20photography%20clean%20warm%20minimalist%20style&width=600&height=400&seq=thumb-beginner-01&orientation=landscape',
  },
  {
    title: 'Best Sugargoo Finds 2026: Trending Products & Hidden Gems',
    desc: 'Curated collection of the most popular and unique Sugargoo discoveries this year. Sneakers, streetwear, electronics, and surprising gems the community loves.',
    path: '/sugargoo-best-finds',
    img: 'https://readdy.ai/api/search-image?query=A%20wooden%20treasure%20chest%20partially%20open%20revealing%20small%20fashion%20accessories%20a%20watch%20and%20sunglasses%20on%20a%20cream%20surface%20with%20soft%20natural%20lighting%20editorial%20photography%20warm%20earthy%20tonal%20aesthetic&width=600&height=400&seq=thumb-finds-01&orientation=landscape',
  },
  {
    title: 'Sugargoo Warehouse Guide: Storage, QC Photos & Consolidation',
    desc: 'Everything about the Sugargoo warehouse — how storage works, requesting QC inspection photos, combining multiple orders, and maximizing warehouse benefits.',
    path: '/sugargoo-warehouse-guide',
    img: 'https://readdy.ai/api/search-image?query=A%20neatly%20organized%20storage%20shelf%20with%20small%20parcels%20and%20shipping%20boxes%20stacked%20orderly%20in%20a%20bright%20clean%20room%20with%20soft%20lighting%20editorial%20photography%20warm%20neutral%20tones%20minimalist%20industrial%20aesthetic&width=600&height=400&seq=thumb-warehouse-01&orientation=landscape',
  },
  {
    title: 'Sugargoo vs Alternatives: Complete Shopping Agent Comparison',
    desc: 'Detailed comparison of Sugargoo versus PandaBuy, CSSBuy, Superbuy, and other popular agents. Service quality, pricing, shipping, and overall user experience analyzed.',
    path: '/sugargoo-vs-alternatives',
    img: 'https://readdy.ai/api/search-image?query=Two%20wooden%20scales%20balancing%20small%20shopping%20bags%20on%20each%20side%20on%20a%20cream%20surface%20with%20soft%20natural%20side%20lighting%20conceptual%20product%20photography%20representing%20comparison%20clean%20minimalist%20style&width=600&height=400&seq=thumb-vs-01&orientation=landscape',
  },
  {
    title: 'Sugargoo Shopping Tips: Expert Strategies to Save Money',
    desc: 'Proven money-saving strategies from experienced Sugargoo shoppers. Learn about bulk ordering, seasonal timing, seller negotiation, and shipping consolidation hacks.',
    path: '/sugargoo-shopping-tips',
    img: 'https://readdy.ai/api/search-image?query=A%20ceramic%20piggy%20bank%20next%20to%20a%20small%20shopping%20cart%20miniature%20and%20coins%20scattered%20on%20a%20cream%20surface%20with%20soft%20natural%20lighting%20conceptual%20product%20photography%20warm%20clean%20minimalist%20aesthetic&width=600&height=400&seq=thumb-tips-01&orientation=landscape',
  },
  {
    title: 'Sugargoo Spreadsheet Categories: Complete Product Directory',
    desc: 'Comprehensive overview of every product category available through Sugargoo Spreadsheet resources — from shoes and clothing to electronics and luxury accessories.',
    path: '/sugargoo-spreadsheet-categories',
    img: 'https://readdy.ai/api/search-image?query=A%20beautifully%20organized%20grid%20of%20small%20product%20icons%20representing%20different%20shopping%20categories%20printed%20on%20a%20cream%20paper%20with%20soft%20natural%20lighting%20editorial%20photography%20clean%20minimalist%20style&width=600&height=400&seq=thumb-categories-01&orientation=landscape',
  },
];

export default function ArticleGrid() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            Sugargoo Spreadsheet Guides & Resources
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            In-depth articles covering everything from shipping and safety to discounts and shopping strategies. Your complete Sugargoo Spreadsheet knowledge base.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.path}
              to={article.path}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="group bg-white rounded-xl border border-background-200 hover:border-accent-300 overflow-hidden transition-all duration-200 cursor-pointer flex flex-col"
            >
              <div className="w-full aspect-[3/2] overflow-hidden bg-background-100">
                <img
                  src={article.img}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-950 mb-2 group-hover:text-accent-700 transition-colors duration-200 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-3 flex-1 line-clamp-3">
                  {article.desc}
                </p>
                <span className="inline-flex items-center gap-1 text-xs font-medium text-accent-600 group-hover:text-accent-700 transition-colors duration-200 whitespace-nowrap">
                  Read Article
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}